/*
 * @Author: guoqing 370541946@qq.com
 * @Date: 2025-02-14 17:44:48
 * @FilePath: /insuranceagent-ui/src/util/sensorsUtils.js
 * @Description: 封装神策数据埋点相关操作
 */
// 引入神策 SDK
const sensors = require('sa-sdk-javascript')
import {getDiffEnvConfig} from '@/config/env'

const sensorsUtils = {
	/**
	 * 初始化神策
	 */
	initSensors() {
		const {VUE_APP_SENSORS_URL} = getDiffEnvConfig()
		sensors.init({
			server_url: VUE_APP_SENSORS_URL,
			is_track_single_page: true,
			use_client_time: true,
			send_type: 'ajax',
			// show_log: true,
			heatmap: {
				//是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
				clickmap: 'not_collect',
				//是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
				scroll_notice_map: 'not_collect',
			},
		})
		//注册埋点通用属性
		sensors.registerPage({
			system: 'PC', //操作系统
			operate_source: 'Ie保', //使用的系统,
		})
	},

	/**
	 * 封装登录函数
	 * @param {string} userId - 用户的唯一标识符
	 */
	login(userId) {
		if (!userId) {
			console.error('用户 ID 为空，无法登录神策')
			return
		}
		try {
			sensors.login(userId)
		} catch (error) {
			console.error('登录神策时发生错误:', error)
		}
	},

	/**
	 * 封装事件追踪函数
	 * @param {string} eventName - 要追踪的事件名称
	 * @param {Object} [eventProperties={}] - 事件的相关属性
	 */
	trackEvent(eventName, eventProperties = {}) {
		if (!eventName) {
			console.error('事件名称为空，无法进行事件追踪')
			return
		}
		try {
			sensors.track(eventName, eventProperties)
		} catch (error) {
			console.error('追踪事件时发生错误:', error)
		}
	},
}

export default sensorsUtils
